<script setup lang="ts">
import QRCode from 'qrcode'

const props = defineProps<{
  text: string
}>()

const qrCode = await QRCode.toDataURL(props.text, {
  margin: 0,
}).catch((error) => {
  console.error(error)
})
</script>

<template>
  <img :src="qrCode || ''" alt="QR Code" />
</template>
